import React from "react";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../store/reducers/usersReducer";

const UserMenuItem = ({ username }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutFunction = () => {
    localStorage.removeItem("user");
    dispatch(logoutUser());
    navigate("/login");
  };
  const items = [
    // {
    //   key: "profile",
    //   label: (
    //     <Link href="" className="user-items-link">
    //       <UserOutlined />
    //       Profile
    //     </Link>
    //   ),
    // },
    // {
    //   key: "settings",
    //   label: (
    //     <Link href="" className="user-items-link">
    //       <SettingOutlined />
    //       Settings
    //     </Link>
    //   ),
    // },
    {
      key: "logout",
      label: (
        <div onClick={logoutFunction} className="user-items-link">
          <LogoutOutlined />
          Logout
        </div>
      ),
    },
  ];
  return (
    <div>
      <Dropdown
        menu={{
          items,
        }}
      >
        <Link onClick={(e) => e.preventDefault()}>
          <Space>
            <h3>{username}</h3>
            <UserOutlined />
          </Space>
        </Link>
      </Dropdown>
    </div>
  );
};
export default UserMenuItem;
